import { Box } from "@mui/system";
import React, { useCallback, useEffect, useState } from "react";
import { getUtcDateTime } from "../../../../lib/functions/utils.lib";
import assest from "../../../../json/assest";
import styles from "../../../../styles/components/video.module.scss";
import { Button } from "@mui/material";
import RejectionJustificationModal from "../modals/RejectionJustificationModal";
import { useMutation } from "react-query";
import { createNote, deleteNote } from "../../../../api/functions/note.api";

const WebsiteStatus = ({
  handleCancle,
  notes,
  data,
  refetchNote,
  onClose: onClose2,
}) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [goBack, setGoBack] = useState(false);
  const [defaultNote, setDefaultNote] = useState("");
  const [noteInfo, setNoteInfo] = useState();
  //   console.warn("noteInfo", noteInfo);
  //   console.warn("notes", notes);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  useEffect(() => {
    // if (notes) {
    notes?.map((note) => {
      if (note.type == "admin_website_only_reason") {
        setDefaultNote(note.note);
        setNoteInfo(note);
      }
    });
    // }
  }, [notes]);

  let modalProps = {
    open,
    onClose,
    note,
    setNote,
    defaultNote,
    setDefaultNote,
    setGoBack,
  };

  const { mutate } = useMutation(createNote, {
    onSuccess: (data) => {
      // console.warn("data", data);
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });
  const { mutate: mutateDelete } = useMutation(deleteNote, {
    onSuccess: (data) => {
      // console.warn("data", data);
      refetchNote();
      setNoteInfo(false);
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });
  // console.warn("data", data);

  const handleConfirmNoteRejection = () => {
    if (note) {
      mutate({
        note,
        note_key: "admin_website_only_reason",
        video_id: data.id,
      });
      setDefaultNote(note);
      setGoBack(false);
    }
  };
  return (
    <>
      <RejectionJustificationModal
        modalProps={modalProps}
        headTitle="Website Justification"
      />
      <Box className={`${styles.deleteBox} ${styles.inquirPurpleBoxEdit}`}>
        <Box className={styles.deleteBoxUP}>
          <p>
            This video was <b>Approved</b> for <b>Website-only posting</b> on
            {getUtcDateTime(
              data.video_meta.admin_updated_at ||
                data.video_meta.quality_team_updated_at
            )}
          </p>
          <Button onClick={handleCancle}>
            <img src={assest.purpleRefreshIcon} width={14} height={14} alt="" />{" "}
            Cancel
          </Button>
        </Box>

        {noteInfo && (
          <>
            <Box className={styles.singleBorderWebsite}></Box>

            <Box className={styles.deleteBoxTxt}>
              <Box className={styles.justificationBox}>
                <h5>Justification</h5>
                {!goBack && (
                  <Button
                    onClick={() => {
                      setOpen(true);
                      setNote(defaultNote);
                    }}
                  >
                    <img
                      src={assest.redEditIcon}
                      height={14}
                      width={14}
                      alt=""
                    />
                  </Button>
                )}

                <Box className={styles.afterJustification}>
                  {goBack && (
                    <Button
                      onClick={() => {
                        setGoBack(false);
                      }}
                    >
                      <img
                        src={assest.redRefreshIcon}
                        height={14}
                        width={14}
                        alt=""
                      />
                    </Button>
                  )}
                  {note != defaultNote && goBack && (
                    <Button onClick={handleConfirmNoteRejection}>
                      <img
                        src={assest.fileSaveIcon}
                        height={14}
                        width={14}
                        alt=""
                      />
                    </Button>
                  )}
                </Box>
              </Box>

              <Box className={styles.redRejectedBox}>
                <p>{goBack ? note : defaultNote}</p>
              </Box>
            </Box>
          </>
        )}
        <Box className={styles.crossButton}>
          <Button onClick={onClose2}>
            <img src={assest.crossBlack} width={21} height={21} alt="" />
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default WebsiteStatus;
